var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3474",
    "data-name": "Rectangle 3474",
    width: 24,
    height: 24,
    transform: "translate(1272 442)",
    fill: "#333"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_232",
    "data-name": "Mask Group 232",
    transform: "translate(-1272 -442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "basket-sharp",
    transform: "translate(1270.452 440.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2719",
    "data-name": "Path 2719",
    d: "M18.657,11.661,14.446,6.046l-4.211,5.614-1.3-.972L13.8,4.211a.81.81,0,0,1,1.3,0l4.859,6.478Z",
    transform: "translate(-0.899)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2720",
    "data-name": "Path 2720",
    d: "M22.94,11.661H4.155a.608.608,0,0,0-.591.748l2.725,11.5H20.805l2.726-11.5a.608.608,0,0,0-.591-.748Zm-9.393,8.08a1.908,1.908,0,1,1,1.918-1.906A1.908,1.908,0,0,1,13.548,19.741Z",
    transform: "translate(0 -1.296)",
    fill: "#333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.0659a0eafeafccc8f0efab4d7dbbd174.svg";
export { ForwardRef as ReactComponent };